(function ($) {
    'use strict';

    var $juryItem = $('.jury-item');
    var $body = $('body');

    $juryItem.click(juryClickHandler);
    
    function juryClickHandler(e) {
        e.preventDefault();

        var juryId = $(this).data('jury-id');

        $.get(window.wp.ajaxUrl + '?action=get_jury_modal&jury_id=' + juryId, function (response) {
            var $modal = $(response);

            $modal.prependTo($body);

            setTimeout(function () {
                $body.find('.modal-jury').addClass('active');
                $body.addClass('fixed');
            }, 300);
        });
    }

    $body.on('click', '.modal, .modal-close', function (e) {
        var $modal = $('.modal');

        if (e.target === this) {
            $modal.removeClass('active');
            $body.removeClass('fixed');

            if ($('.modal-jury').length > 0) {
                setTimeout(function () {
                    $('.modal-jury').remove();
                }, 300);
            }
        }
    });
})(jQuery);